export const AMBER_PRIMARY = "#005a50";
export const AMBER_SECONDARY = "#FAAA28";
export const PURPLISH_GREY = "#726F7B";
export const PINKISH_RED = "#DC283C";